import { createAction, props } from '@ngrx/store';

export const hubspotLogin = createAction('[OAuth] User Hubspot Login');

export const hubspotLoginSuccess = createAction(
  '[OAuth] Hubspot Login Success'
);

export const hubspotLoginFailure = createAction(
  '[OAuth] Hubspot Login Failure',
  props<{ error: string }>()
);

export const hubspotCallback = createAction(
  '[OAuth] User Hubspot Callback',
  props<{ code: string; user_id: number }>()
);

export const hubspotCallbackSuccess = createAction(
  '[OAuth] Hubspot Callback Success'
);

export const hubspotCallbackFailure = createAction(
  '[OAuth] Hubspot Callback Failure',
  props<{ error: string }>()
);

export const hubspotLogout = createAction(
  '[OAuth] Logout Hubspot',
  props<{ user_id: number }>()
);

export const hubspotLogoutSuccess = createAction(
  '[OAuth] Hubspot Logout Success'
);

export const hubspotLogoutFailure = createAction(
  '[OAuth] Hubspot Logout Failure',
  props<{ error: string }>()
);

export const googleLogin = createAction('[OAuth] User Google Login');

export const googleLoginSuccess = createAction(
  '[OAuth] Hubspot google Success'
);

export const googleLoginFailure = createAction(
  '[OAuth] Hubspot google Failure',
  props<{ error: string }>()
);

export const googleCallback = createAction(
  '[OAuth] User google Callback',
  props<{ code: string; user_id: number }>()
);

export const googleCallbackSuccess = createAction(
  '[OAuth] Google Callback Success'
);

export const googleCallbackFailure = createAction(
  '[OAuth] Google Callback Failure',
  props<{ error: string }>()
);

export const googleLogout = createAction(
  '[OAuth] Logout Google',
  props<{ user_id: number }>()
);

export const googleLogoutSuccess = createAction(
  '[OAuth] Google Logout Success'
);

export const googleLogoutFailure = createAction(
  '[OAuth] Google Logout Failure',
  props<{ error: string }>()
);
